import {
  createStore,
  GlobalState,
  Master,
  useStateMachine,
} from 'little-state-machine';

import { ObjectType } from '../framework/utils/UtilityTypes';
import { Pages } from './constants/Page';
import { AppConfig } from './models/AppConfig';
import { UserInfoAccessor } from './utils/UserInfoUtils';

const STORAGE = sessionStorage;
const STORE_KEY = 'SyllabusUI';
const INITIAL_GLOBAL_STORE: GlobalState = {
  appConfig: {
    batchRegisterMaxSize: 500, // default 値 (TODO 不要なら消す)
  },
  isGuarding: false, // 画面ガード(連投抑止)
  pageInfo: {},
};

const log = (store: GlobalState) => {
  console.log(store);
  return store;
};

const createGlobalStore = () =>
  createStore(INITIAL_GLOBAL_STORE, {
    name: STORE_KEY,
    middleWares: [log],
    storageType: STORAGE,
  });

const initializeGlobalStore = (
  _state: GlobalState,
  _payload: GlobalState
): GlobalState => INITIAL_GLOBAL_STORE;

const eraseGlobalStore = () => {
  STORAGE.removeItem(STORE_KEY);
};

export const GlobalStoreInitializer = {
  createGlobalStore: createGlobalStore,
  eraseGlobalStore: eraseGlobalStore,
};

const updateAppConfig = (
  state: GlobalState,
  payload: AppConfig
): GlobalState => ({
  ...state,
  appConfig: payload,
});

const setGuard = (state: GlobalState, payload: boolean): GlobalState => ({
  ...state,
  isGuarding: payload,
});

const updatePageInfo = (
  state: GlobalState,
  payload: { [K in Pages]?: ObjectType }
): GlobalState => {
  const store = {
    ...state,
  };
  Object.keys(payload).forEach(
    (k) =>
      (store.pageInfo[k as Pages] = {
        ...store.pageInfo[k as Pages],
        ...payload[k as Pages],
      })
  );
  return store;
};

const clearAllPageInfo = (
  state: GlobalState,
  _payload: EmptyObject
): GlobalState => ({
  ...state,
  pageInfo: {},
});

const clearPageInfo = (state: GlobalState, payload: Pages): GlobalState => {
  const store = {
    ...state,
  };
  store.pageInfo[payload] = undefined;
  return store;
};

const updateUserInfo = (state: GlobalState): GlobalState => {
  UserInfoAccessor.setUserInfo();

  return { ...state, userInfo: UserInfoAccessor.getUserInfo() };
};

const updateMaster = (
  state: GlobalState,
  payload: Record<string, Array<Master>>
) => ({ ...state, master: payload });

export const useGlobalStateMachine = () =>
  useStateMachine({
    initializeGlobalStore: initializeGlobalStore,
    updateAppConfig: updateAppConfig,
    setGuard: setGuard,
    updatePageInfo: updatePageInfo,
    clearAllPageInfo: clearAllPageInfo,
    clearPageInfo: clearPageInfo,
    updateUserInfo: updateUserInfo,
    updateMaster: updateMaster,
    toggleInitialSignIn: (
      state: GlobalState,
      _payload?: unknown
    ): GlobalState => ({
      ...state,
    }),
    chengeUser: (state: GlobalState, payload: number) => {
      if (state.userInfo?.id === '5') {
        const info = {
          id: '1',
          account: '001',
          name: 'SE　太郎',
          email: '',
          organizationCode: '',
          tel: '',
          staffId: '',
          nameK: '',
          occupation: '',
          roleIds: ['1'],
          familyNameK: '',
          givenNameK: '',
          facilityPid: 1,
          userCode: '001',
          roleType: '0',
          personal_info_agree_required: false,
          password_change_required: false,
        };
        UserInfoAccessor.overwriteUserInfo(info);

        return { ...state, userInfo: info };
      }
      return updateUserInfo(state);
    },
  });
